import React, { useState } from 'react';

import { Button } from '../common/Button';
import { Select } from '../common/Select';
import { Tooltip } from '../tooltips';
import { View } from '../common/View';

type ActionSelectProps = {
  options: [string, string][];
  onChange: (value: string) => void;
  defaultLabel?: string;
  icon?: JSX.Element;
  showLabel?: boolean;
  adoptionId?: string;
  menuOffsetLeft?: number;
};

const ActionSelect: React.FC<ActionSelectProps> = ({
  options,
  onChange,
  defaultLabel = 'Select an option',
  icon,
  showLabel = true,
  adoptionId,
  menuOffsetLeft,
}) => {
  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <Button
      data-adoption-id={adoptionId}
      bounce={false}
      style={{ gap: 4 }}
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      {icon || null}
      <Select
        bare
        options={options}
        style={{ minWidth: showLabel ? 100 : 16, padding: 0 }}
        defaultLabel={showLabel ? defaultLabel : ''}
        value=""
        onChange={onChange}
        menuOffsetLeft={menuOffsetLeft}
      />
      {!showLabel && isMouseOver && (
        <Tooltip
          position="bottom-right"
          style={{ padding: 0 }}
          onClose={() => setIsMouseOver(false)}
        >
          <View style={{ padding: 12 }}>{defaultLabel}</View>
        </Tooltip>
      )}
    </Button>
  );
};
export default ActionSelect;
